import { Typography, IconButton, Tooltip } from '@material-ui/core';
import LaunchIcon from '@material-ui/icons/Launch';
import {
	InfoWindow,
	Marker, MarkerClusterer,
} from '@react-google-maps/api';
import React from 'react';
import {
	isMobile,
	isBrowser
} from "react-device-detect";
import { useActions, useValues } from 'kea';
import CloseIcon from '@material-ui/icons/Close';

import assetlogic from 'src/store/asset';
import { assetmaplogic, preferenceslogic, assetreplaylogic, assetinfowindowlogic } from 'src/store/global';
import NoImage from '../../../resources/tracker-icons/BluetoothBecon.png';

function DrawAsset() {

	const { replay } = useValues(preferenceslogic);

	const { fetchUpdatedPosition, setHistory } = useActions(assetlogic);

	const { assets, updatePosition } = useValues(assetmaplogic);
	const { removeOne } = useActions(assetmaplogic);

	const { asset, index } = useValues(assetreplaylogic);
	const { setIndex } = useActions(assetreplaylogic);

	const { set: setInfoWindowasset } = useActions(assetinfowindowlogic);

	React.useEffect(() => {
		let lastts = new Date();
		const update = async () => {
			if (assets.length > 0 && updatePosition) {
				await fetchUpdatedPosition(assets, lastts);
				lastts = new Date();
			}
		}
		const interval = setInterval(update, 5000);
		return () => clearInterval(interval);
		// eslint - disable - next - line react - hooks / exhaustive - deps
	}, [assets, updatePosition]);


	const handleClickOptions = tracker => {
		setInfoWindowasset(tracker);
		setHistory([])
	}

	const handleMarkerLoad = (marker) => {

	}

	const handleHide = (asset) => () => {
		removeOne(asset)
	}


	//width & height of marker icon
	const markerIconSize = 64;


	return (
		<>
			{
				replay.show ?
					<>
					</>
					:
					// The previous locations
					<MarkerClusterer options={{
						imagePath:
							'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
					}}>
						{
							(clusterer) => {
								let res = assets.map((item) => {
									if (!item.beacon || item.beacon.positions.length === 0) {
										return null;
									}
									let initial_status = item.beacon.positions[0];
									// assign icon type for use in marker
									// let icon = () => <Avatar alt={item.name} src="../../../resources/tracker-icons/ladder.jpg" />

									return (
										<Marker
											icon={{
												url: item?.image?.image || NoImage,
												scaledSize: new window.google.maps.Size(markerIconSize, markerIconSize),
												origin: new window.google.maps.Point(0, 0),
												anchor: new window.google.maps.Point(32, 32),
											}}
											style={{
												verticalAlign: 'middle',
												width: '50px',
												height: '50px',
												borderRadius: '50%'
											}}
											position={{
												lat: initial_status.latitude,
												lng: initial_status.longitude
											}}
											clusterer={clusterer}
											onLoad={handleMarkerLoad}
										>
											<InfoWindow
												zIndex={9998}
											>
												<>
													{
														isBrowser && <div style={{
															display: 'flex',
															flexGrow: 1,
															alignItems: 'center'
														}}>
															{/* <Avatar alt={item.name} src={Ladderr} /> */}
															<Typography
																style={{ marginRight: '36px', marginLeft: '10px' }}
															>
																{item.name}
															</Typography>
															<Tooltip title='Open the Asset Info Panel'>
																<IconButton
																	aria-label="more"
																	aria-controls="long-menu"
																	aria-haspopup="true"
																	onClick={() => handleClickOptions(item)}
																	size='small'
																>
																	<Typography>Open</Typography>
																	<LaunchIcon />
																</IconButton>
															</Tooltip>
															<Tooltip title='Hide this Asset'>
																<IconButton
																	aria-label="more"
																	aria-controls="long-menu"
																	aria-haspopup="true"
																	onClick={handleHide(item)}
																	size='small'
																>
																	<CloseIcon />
																</IconButton>
															</Tooltip>
														</div>
													}
													{
														isMobile &&
														<Typography>
															{item.name}
														</Typography>
													}
												</>
											</InfoWindow>
										</Marker>
									)
								})
								return res.filter((i) => i !== null);
							}
						}
					</MarkerClusterer>
			}
		</>
	)
}

export default DrawAsset;